<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4">
        <h2
          v-if="title"
          class="text-center text-xl font-semibold text-highlighted"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="text-center text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <div
          v-if="!magnetId || builderPreview"
          class="rounded-2xl border border-dashed border-primary/30 p-6 text-center text-sm text-muted"
        >
          چک‌لیست رایگان
        </div>
        <LeadFlowShell
          v-else
          :labels="['موبایل', 'چک‌لیست']"
          :step="step"
          :loading="saving"
          :next-disabled="!isCompleteIrMobile(phone)"
          :next-label="step === 0 ? 'دریافت چک‌لیست' : 'تمام'"
          :show-next="step === 0"
          @next="submit"
          @back="step = 0"
        >
          <AuthPhoneInput
            v-if="step === 0"
            v-model="phone"
          />
          <ul
            v-else
            class="space-y-2 text-sm"
          >
            <li
              v-for="item in items"
              :key="item"
              class="rounded-xl bg-[var(--ui-bg-muted)] px-3 py-2"
            >
              {{ item }}
            </li>
          </ul>
        </LeadFlowShell>
        <p
          v-if="error"
          class="text-center text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  magnetId?: string
  builderPreview?: boolean
}>()

const phone = ref('')
const step = ref(0)
const saving = ref(false)
const error = ref('')
const items = ref<string[]>([])

async function submit() {
  if (!props.magnetId || props.builderPreview) return
  saving.value = true
  error.value = ''
  try {
    const res = await $fetch<{ item: { checklistItems: string[] } }>(`/api/leads/magnets/${props.magnetId}/submit`, {
      method: 'POST',
      body: { phone: phone.value },
    })
    items.value = res.item.checklistItems ?? []
    step.value = 1
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ارسال ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
